// extracted by mini-css-extract-plugin
export default {"root":"PastINVAnalysisHistoryPage_root__uJ-dp"};